import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Crud, CrudService, ConfigServerService, CustomHttp } from '../../../../core';
import { Cliente } from '../cliente';
import { ClienteSearchAsync } from './cliente-search-async';
import { Filter } from '../../../../models';

@Injectable({
    providedIn: 'root'
})
export class ClienteCrudHttpService implements Crud<Cliente> {
    resource = 'cliente';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todos os clientes cadastrados */
    search(): Observable<Cliente[]> {
        return this.crudService.search<Cliente>(this.resource);
    }

    searchWithFilter(filter: Filter, drawDatatable: number, offset: number, limit: number, orderBy: number, orderByDir: string): Observable<ClienteSearchAsync> {
        // Params
        let params = new HttpParams()
                            .append('drawDatatable', drawDatatable.toString())
                            .append('offset', offset.toString())
                            .append('limit', limit.toString())
                            .append('orderBy', orderBy.toString())
                            .append('orderByDir', orderByDir ? orderByDir : '');
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<ClienteSearchAsync>(this.pathApi, {params});
    }

    /** Procura um único cliente através do seu ID */
    find(id: number): Observable<Cliente> {
        return this.crudService.find<Cliente>(this.resource, id);
    }

    /** Carrega um único cliente através do seu ID */
    load(id: number): Observable<Cliente> {
        return this.crudService.load<Cliente>(this.resource, id)
                    .pipe(
                        map(cliente => {
                            // Classificações
                            cliente?.classificacoes?.forEach(classificacao => {
                                // Setando que pode editar a classificação
                                classificacao.canEdit = true;
                            })

                            return cliente;
                        })
                    );
    }

    /** Insere um novo cliente */
    insert(entity: Cliente): Observable<Cliente> {
        return this.crudService.insert<Cliente>(this.resource, entity);
    }

    /** Altera um cliente existente */
    update(entity: Cliente): Observable<Cliente> {
        return this.crudService.update<Cliente>(this.resource, entity);
    }

    /** Exclui um cliente através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
